import { graphql, useStaticQuery } from 'gatsby';
import React from 'react';
import { Helmet } from 'react-helmet';

type SeoProps = {
  lang?: string;
  title?: string;
  titleTemplate?: string;
  description?: string;
  image?: string;
  url?: string;
  author?: string;
};

const Seo: React.FC<SeoProps> = props => {
  const meta = [];
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
            siteUrl
          }
        }
      }
    `,
  );

  if (props.title) {
    meta.concat([
      {
        property: 'og:title',
        content: props.title,
      },
      {
        property: 'twitter:title',
        content: props.title,
      },
    ]);
  }

  if (props.description) {
    meta.concat([
      {
        property: 'description',
        content: props.description,
      },
      {
        property: 'og:description',
        content: props.description,
      },
      {
        property: 'twitter:description',
        content: props.description,
      },
    ]);
  }

  if (props.author) {
    meta.push({
      property: 'twitter:creator',
      content: props.author,
    });
  }

  if (props.image) {
    meta.push({
      property: 'og:image',
      content: `${site.siteMetadata.siteUrl}${props.image}`,
    });
  }

  return (
    <Helmet
      htmlAttributes={{
        lang: props.lang,
      }}
      title={props.title}
      titleTemplate={props.titleTemplate}
      meta={meta}
    >
      {props.url && <link rel="canonical" href={props.url} />}
    </Helmet>
  );
};

Seo.defaultProps = {
  lang: 'en',
  titleTemplate: '%s | Architect.io',
};

export default Seo;
